var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrupoilt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54719 12.2013L12.2201 11.2704L13.7547 16L8.54719 12.2013ZM17 6.08805H10.5346L8.54719 0L6.55977 6.08805H0.0943604L5.32707 9.86164L3.33964 15.9497L8.57235 12.1761L11.7925 9.86164L17 6.08805Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrupoilt);
export default __webpack_public_path__ + "static/media/trupoilt.a33e4581c98f97a6d93f38bc506c9e52.svg";
export { ForwardRef as ReactComponent };